import { AudioRecording } from 'src/components/molecules';
import { CallRecordingUrlType, CallStep } from 'src/graphql';

const EventAudio = (props: {
  showAudioRecordings?: boolean;
  getStepRecording: (step: CallStep) => '' | CallRecordingUrlType;
  stepType: CallStep;
  testId?: string;
}) => {
  const { showAudioRecordings, getStepRecording, stepType, testId } = props;
  const step = getStepRecording(stepType);
  if (!(showAudioRecordings && step) || step?.dataDeletedAt) return null;
  return (
    <AudioRecording
      audioType="audio/mpeg"
      audioSource={step?.url}
      data-testid={testId}
    />
  );
};

export default EventAudio;
